<template>
    <div>
        <div class="content re_flex_between distance" style="margin-top: 16px;" v-if="slign == 1 && active == 1 && detail.distance">
            <div>与TA相距</div>
            <div>
                <span v-if="detail.cityDisplay">{{detail.userCityName}} | </span>
                <span>距离{{detail.distance}}</span>
            </div>
        </div>
        <div class="content" :style="{'margin-top': slign == 1 && active == 1 && detail.distance ? 8 : 16 + 'px',}">
            <div class="title_cont">个人介绍</div>
            <div class="content_user re_flex" v-if="active == 1 && slign == '1' && detail.userPhoto">
                <div class="avatar">
                    <img :src="detail.userPhoto" alt="">
                </div>
                <div class="cont_user">
                    <div class="cont_name">
                        <div>{{ detail.userNick }}</div>
                        <!-- <img src="@assets/blindBox/xueli.png" alt="" /> -->
                    </div>
                    <div class="cont_introduce">{{ detail.userVipRank }}</div>
                </div>
            </div>
            <van-text-ellipsis class="text_ellipsis" rows="3" :content="detail.userIntroduce" expand-text="展开"
                collapse-text="收起" />
        </div>
        <div class="content">
            <div class="title_cont">基本信息</div>
            <div class="item" v-if="detail.userSchool && detail.boxCover.indexOf('school') != -1">
                <div>{{ slign == '1' ? '毕业学校：' : '所在学校：' }}</div>
                <div class="item_content">{{ detail.userSchool }}</div>
            </div>
            <div class="item" v-if="detail.userConstellation && detail.boxCover.indexOf('constellation') != -1">
                <div>星座：</div>
                <div class="item_content">{{ detail.userConstellation }}</div>
            </div>


            <div class="item" v-if="detail.userEducation && slign == '1' && detail.boxCover.indexOf('education') != -1">
                <div>学历：</div>
                <div class="item_content">{{ detail.userEducation }}</div>
            </div>
            <div class="item" v-if="detail.userInterest && detail.boxCover.indexOf('interest') != -1">
                <div>TA的兴趣：</div>
                <div class="item_content">{{ detail.userInterest }}</div>
            </div>
            <div class="item" v-if="detail.userHeight && slign == '1' && detail.boxCover.indexOf('height') != -1">
                <div>身高：</div>
                <div class="item_content">{{ detail.userHeight }}cm</div>
            </div>
            <div class="item" v-if="detail.userOccupation && slign == '1' && detail.boxCover.indexOf('occupation') != -1">
                <div>职业：</div>
                <div class="item_content">{{ detail.userOccupation }}</div>
            </div>
            <div class="item" v-if="detail.userSn">
                <div>电报号：</div>
                <div class="item_content">{{ detail.userSn }}</div>
            </div>


            <div class="item" v-if="detail.createTime && slign == '1'">
                <div>{{ active == 0 ? '发布时间' : '开盒时间' }}：</div>
                <div class="item_content">{{ detail.createTime }}</div>
            </div>
            <div class="item" v-if="detail.boxGiftName && active == 0">
                <div>开盒条件：</div>
                <div class="item_content">{{ detail.boxGiftName }}</div>
            </div>

            <div class="item" v-if="detail.boxId && active == 0">
                <div>投放区域：</div>
                <div class="item_content">{{ detail.boxRegionName || '不限' }}</div>
            </div>
            <div class="item" v-if="detail.createTime && slign == '0'">
                <div>{{ active == 0 ? '发布时间' : '开盒时间' }}：</div>
                <div class="item_content">{{ detail.createTime }}</div>
            </div>
            <div class="item" v-if="detail.userCharacter">
                <div>性格特征：</div>
                <div class="item_content">{{ detail.userCharacter }}</div>
            </div>
        </div>
        <div class="content" v-if="active == 1 && llhDetail.llhTotalInitState == 1">
            <div class="item_btw" @click="goDynamic">
                <div>最近动态</div>
                <div class="item_content re_flex">
                    <span class="van-badge" v-if="llhDetail.llhTotal > 0">{{ llhDetail.llhTotal }}</span>
                    <van-icon class="icon" name="arrow" size="16"/>
                </div>
            </div>
        </div>
        <div class="content" v-if="active == 1 && llhDetail.medalLevel">
            <div class="item_btw" @click="goAppleTree">
                <div>TA的苹果乐园</div>
                <div class="item_content">
                    <img v-if="llhDetail.medalLevel == 'LV.0'" src="https://tp.kaishuihu.com/static/apple_medal/apple_seed_s.png" alt="">
                    <img v-if="llhDetail.medalLevel == 'LV.1'" src="https://tp.kaishuihu.com/static/apple_medal/apple_sprouting_s.png" alt="">
                    <img v-if="llhDetail.medalLevel == 'LV.2'" src="https://tp.kaishuihu.com/static/apple_medal/apple_tree_s.png" alt="">
                    <img v-if="llhDetail.medalLevel == 'LV.3'" src="https://tp.kaishuihu.com/static/apple_medal/green_apple_s.png" alt="">
                    <img v-if="llhDetail.medalLevel == 'LV.4'" src="https://tp.kaishuihu.com/static/apple_medal/red_apple_s.png" alt="">
                    <img v-if="llhDetail.medalLevel == 'LV.5'" src="https://tp.kaishuihu.com/static/apple_medal/golden_apple_s.png" alt="">
                    <van-icon class="icon" name="arrow" size="16" />
                </div>
            </div>
        </div>
        <div class="cont_thumbs" v-if="detail.boxStatus == 2 || detail.boxStatus == 3">
            <div class="thumbs give_up" @click="supportOpposeFn(1)">
                <div>
                    <img src="@assets/blindBox/give_up.png" alt="" srcset="">
                </div>
                <div>点赞 {{ detail.support || 0 }}</div>
            </div>
            <div class="thumbs step_on" @click="supportOpposeFn(0)">
                <div>
                    <img src="@assets/blindBox/step_on.png" alt="" srcset="">
                </div>
                <div>吐槽 {{ detail.oppose || 0 }}</div>
            </div>
        </div>

        <div class="content" v-if="active == 0 && (detail.boxStatus == -1 || detail.boxStatus == 0) ">
            <div class="item item_user noborder" style="justify-content: start;">
                <div>审核结果：</div>
                <div class="item_content">未通过</div>
            </div>
            <div class="item item_user noborder" style="justify-content: start;">
                <div>审核原因：</div>
                <div class="item_content">{{ detail.remark }}</div>
            </div>
        </div>

        <div class="content"
            v-if="(detail.boxStatus == 2 || detail.boxStatus == 3) && active == 0 && userList.length > 0">
            <div class="title_cont" style="margin: 0;">开泡泡用户</div>
            <div class="title_tips">请在开泡泡后24小时内与TA聊天，才可获取礼物</div>
            <div class="chat_item" :style="{border: index == 0 ? 'none' : ''}" v-for="(item, index) in userList" :key="index">
                <div class="item item_user" :class="index == 0 ? 'noborder' : ''">
                    <div class="re_flex">
                        <div>
                            <img :src="item.userPhoto" alt="">
                        </div>
                        <div>
                            <div class="name">
                                <div>{{ item.userNick }}</div>
                                <img src="@assets/blindBox/vip.png" alt="" v-if="item.userVip == 1" />
                            </div>
                            <div class="time">{{ item.createTime }}</div>
                        </div>
                    </div>
                    <div class="re_flex_center" @click="toChat(item, 'her')">聊天</div>
                </div>
                <div class="chat" v-if="item.giveGiftTip">{{item.giveGiftTip}}</div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import { showLoadingToast, closeToast } from 'vant';
import { singleSupportOppose, supportOppose } from '../api'
import { getShowAppleTree } from '../../appleTree/api'
const router = useRouter();
const emit = defineEmits(['getDetail', 'toChat', 'closeRedio']);

const props = defineProps({
    detail: {
        type: Object,
        default: () => {},
    },
    active: {
        type: String || Number,
        default: 0,
    },
    slign: {
        type: String,
        default: '0',
    },
    userList: {
        type: Array,
        default: () => [],
    },
    llhDetail: {
        type: Object,
        default: () => { },
    }
});
watch(() => props.detail, (val) => {
    if (val) {
        if(props.active == 1) {
            getAppleTree()
        }
    }
})

const showTree = ref('1')
const getAppleTree = () => {
    getShowAppleTree({owner: props.detail.userId}).then(res => {
        console.log(res)
        if (res.code == 1) {
            showTree.value = res.data
            // goAppleTree.val = res.data
        }
    })
}
const toChat = (item, type) => {
    emit('toChat', item, type)
}
// 去动态页
const goDynamic = () => {
    let u = navigator.userAgent;
    let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
    let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isiOS) {
        window.webkit.messageHandlers.AppModel.postMessage({
            name: 'goDynamic',
            userId: props.detail.userId
        });
    }
    if (isAndroid) {
        appJsImp.goDynamic(props.detail.userId);
    }
    emit('closeRedio')
}
const goAppleTree = () => {
    sessionStorage.setItem('appleTree', 'true')
    if (showTree.value == '1') {
        router.push({ path: '/appleTree', query: { owner: props.detail.userId, isH5: 1, user_id: props.detail.boxRecordUserId } });
    } else {
        router.push({ path: '/appleTree/noVisit', query: { isH5: 1} });
    }
    
}
const supportOpposeFn = (type) => {
    if (props.active == 0) return
    // toast
    let url = props.slign == '0' ? supportOppose : singleSupportOppose
    showLoadingToast()
    url({ boxId: props.detail.boxId, type: type }).then(res => {
        closeToast()
        if (res.code == 1) {
            emit('getDetail')
        }
    })
}
</script>
<style lang="less" scoped>
@import '../detail.less';
</style>